'use strict';
import noChartImage from '../../../assets/images/no-chart-icon.svg';
import { initFilterExpression } from '../../model/filterExpressionUtils';

angular.module('mx.SolutionBuilderAgent').factory('mx.SolutionBuilderAgent.BaseChartService', mxBaseChartService);
angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.MxBaseChartController', MxBaseChartCtrl);

function mxBaseChartService() {
	return {
		mxBaseChartDirective: mxBaseChartDirective,
		getBaseChartConfig: async (vm) => {
			const currentTheme = await vm.themeService.getCurrentTheme();
			return await getBaseChartConfig(vm, currentTheme);
		},
	};
}

function mxBaseChartDirective($injector) {
	return {
		restrict: 'E',
		require: {
			m42DashboardWidgetCustom: '?^m42DashboardWidgetCustom',
			mxCommonLandingPageContent: '?^mxCommonLandingPageContent',
			parentViewController: '?^^mxView',
			mxContainerCtrl: '?^^mxContainer',
		},
		scope: {},
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-charts/mx-charts.html',
		bindToController: {
			data: '<?',
			loadingState: '<?', // 0 - initial, 1 - loading, 2 - loaded, 3 - rejected
			legendFieldName: '@',
			valueFieldName: '@',
			itemColorFieldName: '@',
			seriesColorFieldName: '@',
			stackFieldName: '@',
			detailsEntityClassName: '@',
			detailsColumnDefinition: '@',
			detailsEntityType: '@',
			detailsObjectId: '@',
			selectedItem: '=?',
			titleXAxis: '@',
			titleYAxis: '@',
			labelsFormat: '@',
			legendVisible: '@',
			legendLayout: '@',
			legendAlign: '@',
			legendVerticalAlign: '@',
			noDataMessage: '@',
			detailsType: '@',
			detailsTitle: '@',
			tooltipFormat: '@',
			chartTitle: '@',
			titleAlign: '@',
			mxAtId: '@',
		},

		link: function (scope, element, attrs, ctrls) {
			var widget = ctrls[0],
				landingPage = ctrls[1];

			var dashboardDataService = $injector.get('mx.SolutionBuilderAgent.DashboardWidgetDataService');
			var eventService = $injector.get('mx.shell.EventService');

			scope.vm.chartContainer = '.chart-container';

			element.css('width', '100%');
			element.css('height', '100%');

			if (widget) {
				scope.vm.locatedInLPWidget = true;
				scope.vm.widgetTitle = widget.title;
			}

			scope.vm.noChartImage = noChartImage;

			scope.vm.removeWidget = function () {
				dashboardDataService.removeWidgetFromDashboard(widget.m42Params.dashboardId, widget.m42WidgetId);
				landingPage.dashboardPublicFunctions.deleteWidgetById(widget.m42WidgetId);
			};

			function renderChart() {
				if (!scope.vm.chartContainer) {
					scope.vm.chartContainer = element;
				} else if (typeof scope.vm.chartContainer === 'string') {
					var findEl = element.find(scope.vm.chartContainer);
					if (findEl.length > 0) {
						scope.vm.chartContainer = angular.element(findEl[0]);
					} else {
						scope.vm.chartContainer = element;
					}
				}

				scope.vm.getChartConfig().then(function (config) {
					scope.vm.chart = window.Highcharts.chart(scope.vm.chartContainer[0], config);
				});
			}

			scope.vm.requestChartRerender = function () {
				if (!scope.vm.highchartsLoaded || !scope.vm.hasData || !scope.vm.hasChartSize) {
					return;
				}

				if (scope.vm.dataChanged) {
					renderChart();
				} else if (scope.vm.sizeChanged) {
					if (scope.vm.chart) {
						scope.vm.chart.setSize(scope.vm.chartWidth, scope.vm.chartHeight, true);
					}
				}

				scope.vm.dataChanged = scope.vm.sizeChanged = false;
			};

			scope.vm.dataWatcher = scope.$watch(
				'vm.data',
				function () {
					if (!scope.vm.data || scope.vm.data.length === 0) {
						scope.vm.hasData = false;
						if (scope.vm.chartContainer.empty) {
							scope.vm.chartContainer.empty();
						}
						return;
					}
					scope.vm.hasData = true;
					scope.vm.dataChanged = true;
					scope.vm.requestChartRerender();
				},
				true
			);

			var _setSizes = $.debounce(500, function () {
				if (!element.is(':visible')) {
					return;
				}
				scope.$evalAsync(function () {
					scope.vm.chartHeight = element.height();
					scope.vm.chartWidth = element.width();
					scope.vm.smallHeight = scope.vm.chartHeight < 160;

					scope.vm.hasChartSize = true;
					scope.vm.sizeChanged = true;
					scope.vm.requestChartRerender();
				});
			});
			eventService.subscribeTo(mx.shell.EventCodes.LayoutChanged, _setSizes, scope);
			scope.$evalAsync(function () {
				_setSizes();
			});

			eventService.subscribeTo(
				mx.shell.EventCodes.ThemeChanged,
				async () => {
					const config = await scope.vm.getChartConfig();
					scope.vm.chart?.update(config);
				},
				scope
			);

			if (ctrls.mxContainerCtrl) {
				ctrls.mxContainerCtrl.registerChild(scope);
			}
		},
		controllerAs: 'vm',
	};
}

MxBaseChartCtrl.$inject = ['$injector', '$scope', '$attrs', '$element', 'mx.shell.Config'];

function MxBaseChartCtrl($injector, $scope, $attrs, $element, mxConfig) {
	const vm = $scope.vm;
	const $timeout = $injector.get('$timeout');
	const $ocLazyLoad = $injector.get('$ocLazyLoad');
	const lazyLoadCfg = $injector.get('mx.components.LazyLoadCfg');
	const dialogOpenerService = $injector.get('mx.SolutionBuilderAgent.DialogOpenerService');
	const i18n = $injector.get('mx.internationalization');
	const sideLayout = $injector.get('mx.shell.SideLayout');
	vm.themeService = $injector.get('mx.app.ThemeService');
	vm.chartsI18n = i18n.get('solutionBuilderAgent.components.mx-charts');
	vm.highchartsLoaded = false;
	vm.getColorSet = getColorSet;
	const anticache = `?anticache=${mxConfig.settings.productVersion}`;
	$ocLazyLoad
		.load({
			serie: true,
			files: [`${lazyLoadCfg.componentsDir}highcharts/highcharts.js${anticache}`, `${lazyLoadCfg.componentsDir}highcharts/modules/accessibility.js${anticache}`],
		})
		.then(function () {
			vm.highchartsLoaded = true;
			vm.requestChartRerender();
		});

	vm.$onInit = function () {
		vm.noRequiredData = vm.noDataMessage || vm.chartsI18n.noRequiredData;

		initFilterExpression({
			propertyName: 'details-filter-expression',
			controlMxAtId: vm.mxAtId,
			$scope,
			$attrs,
			$element,
			controller: vm,
		});
	};

	vm.getChartConfig = async function () {
		const currentTheme = await vm.themeService.getCurrentTheme();
		return await getBaseChartConfig(vm, currentTheme);
	};
	vm.onChartClick = onChartClick;

	// This method reorders the series data in the same order as the first series.
	// It does not affect visualization and just affects the order of elements in DOM-structure, and that's why change focus order.
	// So this method sets more predictable focus order by tab-key for Stacked Column/Bar Charts.
	vm.reorderAllStackedSeriesAsFirstSeries = (series) => {
		if (series?.[0]?.data?.length) {
			for (let i = 1; i < series?.length; i++) {
				series[i].data?.sort((a, b) => {
					let aIndex = series[0].data.findIndex((el) => a?.name && el?.name === a.name);
					aIndex = aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex;
					let bIndex = series[0].data.findIndex((el) => b?.name && el?.name === b.name);
					bIndex = bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex;
					return aIndex - bIndex;
				});
			}
		}
		return series;
	};

	return vm;

	function onChartClick(chart) {
		var chartTitle = vm.stackFieldName ? chart.name + ', ' + chart.series.name : chart.name;

		$scope.$apply(function () {
			(vm.data || []).some(function (item) {
				if (
					(!vm.stackFieldName && item[vm.legendFieldName] === chart.name) ||
					(vm.stackFieldName && item[vm.stackFieldName] === chart.name && item[vm.legendFieldName] === chart.series.name)
				) {
					vm.selectedItem = item;
					return true;
				}
			});
		});

		$timeout(function () {
			var detailsType;

			if (typeof vm.detailsType !== 'undefined') {
				detailsType = vm.detailsType;
			} else if (vm.detailsEntityClassName) {
				detailsType = 'list';
			} else if (vm.detailsEntityType) {
				detailsType = 'object';
			} else {
				detailsType = 'none';
			}
			sideLayout.switchFullScreenMode(false);

			switch (detailsType) {
				case 'list':
					var title = vm.widgetTitle ? vm.widgetTitle + ' - ' + chartTitle : chartTitle;
					dialogOpenerService
						.openObjectsListPreview(
							{
								label: i18n.get('solutionBuilderAgent.browseDialog.chart_data'),
								entityClassName: vm.detailsEntityClassName,
								title: vm.detailsTitle || title,
								filterExpression: vm.detailsFilterExpression,
								columnDefinition: vm.detailsColumnDefinition,
								multiSelection: true,
								showActionsPanel: true,
								showSelectAll: true,
							},
							vm.parentViewController && vm.parentViewController.mxView
						)
						.then(function () {
							vm.selectedItem = null;
						})
						.catch(mx.logCatch);
					break;
				case 'object':
					dialogOpenerService.openPreview(
						{
							EntityType: vm.detailsEntityType,
							Id: vm.detailsObjectId,
							DisplayString: vm.detailsTitle || chart.name,
						},
						undefined,
						undefined,
						vm.parentViewController && vm.parentViewController.mxView
					);
					vm.selectedItem = null;
					break;
			}
		});
	}
}

function normalizeColor(color) {
	return typeof color === 'string' ? color.replace(/0xff/i, '#') : null;
}

function getColorSet(currentTheme) {
	const colors = ['#1395ba', '#117899', '#0f5b78', '#0d3c55', '#c02e1d', '#d94e1f', '#f16c20', '#ef8b2c', '#ecaa38', '#ebc844', '#a2b86c', '#5ca793'];
	const enhancedContrastColorsLightMode = ['#003C71', '#1894ff', '#D93F1E', '#676767', '#698F01', '#e87511', '#830ae3', '#0fa78b', '#B7104A', '#AF9023', '#1A704C', '#c970e8'];
	const enhancedContrastColorsDarkMode = ['#0073f5', '#1ebae7', '#ff430f', '#7f7f7f', '#2fff00', '#ff9700', '#ba28ff', '#00ff8c', '#fe0054', '#f2c117', '#098f57', '#ff8fff'];

	if (currentTheme.isContrastTheme) {
		return currentTheme.isDarkTheme ? enhancedContrastColorsDarkMode : enhancedContrastColorsLightMode;
	} else {
		colors.forEach(function (color, index) {
			colors[index] = currentTheme['palette-color' + (index + 1)] || color;
		});
		return colors;
	}
}
function getBorderColor(currentTheme) {
	return currentTheme.isContrastTheme ? (currentTheme.isDarkTheme ? '#000000' : '#FFFFFF') : currentTheme?.['content-bg-color'];
}
function getBorderWidth(currentTheme) {
	return currentTheme.isContrastTheme ? 3 : 2;
}
async function getBaseChartConfig(vm, currentTheme) {
	let defaultLegendConfig = {
			x: 0,
			enabled: vm.legendVisible === 'true',
			layout: vm.legendLayout || 'horizontal',
			align: vm.legendAlign || 'center',
			verticalAlign: vm.legendVerticalAlign || 'bottom',

			itemWidth: undefined,
			maxHeight: undefined,
			itemStyle: {
				width: '',
				textOverflow: '',
				overflow: '',
				fontWeight: '200',
				color: currentTheme['content-text-color'],
				fill: currentTheme['content-text-color'],
			},
			itemHoverStyle: { color: currentTheme['content-text-color'] },
			itemHiddenStyle: { color: currentTheme['content-computed-color2'] },

			navigation: {
				style: { color: currentTheme['content-text-color'] },
				activeColor: currentTheme['content-icon-color'],
				inactiveColor: currentTheme['content-computed-color2'],
			},
		},
		seriesConfig = [];
	vm.defaultLegendConfig = defaultLegendConfig;

	if (vm.data) {
		if (vm.stackFieldName) {
			var usedSeries = [];

			vm.data.forEach(function (item, i) {
				if (usedSeries.indexOf(item[vm.legendFieldName]) >= 0) {
					return;
				}
				usedSeries.push(item[vm.legendFieldName]);

				var serie = {
					borderColor: getBorderColor(currentTheme),
					borderWidth: getBorderWidth(currentTheme),
					name: item[vm.legendFieldName] || vm.chartsI18n.defaultSeries?.replace('{number}', seriesConfig.length + 1),
					color: vm.seriesColorFieldName ? normalizeColor(item[vm.seriesColorFieldName]) : null,
					data: [],
				};

				for (var j = i; j < vm.data.length; j++) {
					var item2 = vm.data[j];

					if (item[vm.legendFieldName] === item2[vm.legendFieldName]) {
						serie.data.push({
							name: item2[vm.stackFieldName],
							y: item2[vm.valueFieldName],
							color: vm.itemColorFieldName ? normalizeColor(item2[vm.itemColorFieldName]) : null,
						});
					}
				}

				seriesConfig.push(serie);
			});
		} else {
			seriesConfig = [
				{
					name: vm.titleYAxis,
					color: vm.seriesColorFieldName && vm.data.length ? normalizeColor(vm.data[0][vm.seriesColorFieldName]) : null,
					data: vm.data.map(function (item) {
						return {
							name: item[vm.legendFieldName],
							y: item[vm.valueFieldName],
							color: vm.itemColorFieldName ? normalizeColor(item[vm.itemColorFieldName]) : null,
						};
					}),
				},
			];
		}
	}

	vm.responsiveLegend = function () {
		var sizeOfGridCell = 170,
			legendItemWidth;

		if (!this.legend || !this.legend.legendWidth) {
			return;
		}

		if (!vm.maxLegendWidth) {
			vm.maxLegendWidth = Math.round(this.legend.legendWidth);
		}

		var legendConfig = angular.copy(vm.defaultLegendConfig);

		if (this.chartHeight > sizeOfGridCell && this.chartWidth - vm.maxLegendWidth < sizeOfGridCell) {
			angular.extend(legendConfig, {
				layout: 'vertical',
				align: 'center',
				verticalAlign: 'bottom',
				maxHeight: Math.round(this.chartHeight / 2),
			});

			if (this.chartWidth < vm.maxLegendWidth) {
				legendItemWidth = Math.round(this.chartWidth - 45);

				angular.extend(legendConfig, {
					itemWidth: legendItemWidth,
					itemStyle: Object.assign({}, vm.defaultLegendConfig.itemStyle, {
						width: legendItemWidth + 'px',
						textOverflow: 'ellipsis',
						overflow: 'hidden',
						whiteSpace: 'nowrap',
					}),
				});
			}
		}

		if (this.chartHeight < sizeOfGridCell) {
			if (this.chartWidth / 2 < vm.maxLegendWidth) {
				legendItemWidth = Math.round(this.chartWidth / 2);

				angular.extend(legendConfig, {
					itemWidth: legendItemWidth,
					itemStyle: Object.assign({}, vm.defaultLegendConfig.itemStyle, {
						width: legendItemWidth + 'px',
						textOverflow: 'ellipsis',
						overflow: 'hidden',
						whiteSpace: 'nowrap',
					}),
				});
			}

			if (this.chartWidth < sizeOfGridCell) {
				angular.extend(legendConfig, { x: sizeOfGridCell * 2 });
			}
		}

		if ($(window).width() < $(window).height()) {
			angular.extend(legendConfig, {
				layout: 'horizontal',
				align: 'center',
				verticalAlign: 'bottom',
			});
		}

		if ($(window).width() < $(window).height()) {
			angular.extend(legendConfig, {
				layout: 'horizontal',
				align: 'center',
				verticalAlign: 'bottom',
			});
		}

		if (!angular.equals(vm.lastLegendConfig, legendConfig)) {
			const options = angular.copy(this.legend.options);

			angular.extend(options, legendConfig);

			this.legend.getAllItems().forEach(function (item) {
				item.legendItem?.css?.(legendConfig.itemStyle);
			});

			vm.lastLegendConfig = legendConfig;

			this.legend.update(options);
		}
	};

	const linesColor = await vm.themeService.getContentColorShade(0.13);

	return {
		yAxis: {
			title: { text: vm.titleYAxis, style: { color: currentTheme['content-text-color'] } },
			accessibility: { description: vm.titleYAxis || vm.chartsI18n.defaultValues },
			labels: { style: { color: currentTheme['content-text-color'] } },
			lineColor: currentTheme['content-computed-color2'],
			gridLineColor: linesColor,
			minorGridLineColor: linesColor,
			minorTickColor: currentTheme['content-computed-color3'],
			tickColor: currentTheme['content-computed-color2'],
		},
		xAxis: {
			title: { text: vm.titleXAxis, style: { color: currentTheme['content-text-color'] } },
			accessibility: { description: vm.titleXAxis || vm.chartsI18n.defaultCategories },
			labels: { style: { color: currentTheme['content-text-color'] } },
			lineColor: currentTheme['content-computed-color2'],
			gridLineColor: linesColor,
			minorGridLineColor: linesColor,
			minorTickColor: currentTheme['content-computed-color3'],
			tickColor: currentTheme['content-computed-color2'],

			type: 'category',
			categories: !vm.stackFieldName ? null : _.uniq(vm.data.map((item) => item[vm.stackFieldName])),
		},
		legend: defaultLegendConfig,
		title: {
			text: vm.chartTitle || '',
			align: vm.titleAlign,
			style: vm.chartTitle ? { color: currentTheme['content-text-color'] } : { display: 'none' },
		},
		chart: {
			backgroundColor: 'transparent',
			colorCount: 12,
		},
		colors: getColorSet(currentTheme),
		subtitle: { text: '' },
		exporting: { buttons: { contextButton: { enabled: false } } },
		credits: { enabled: false },
		tooltip: {
			formatter: function () {
				var y = this.y % 1 === 0 ? this.y : Number(this.y).toFixed(2);
				var x = this.key;
				var s = this.series.name;
				var p = (this.percentage % 1 === 0 ? this.percentage : Number(this.percentage).toFixed(2)) + '%';
				var t = this.total;

				if (typeof vm.tooltipFormat === 'string' && vm.tooltipFormat.length > 0) {
					return vm.tooltipFormat.replace(/{x}/g, x).replace(/{y}/g, y).replace(/{s}/g, s).replace(/{p}/g, p).replace(/{t}/g, t);
				} else {
					return vm.stackFieldName ? s + ' — ' + y : x + ' — ' + y;
				}
			},
		},
		plotOptions: {
			series: {
				borderColor: getBorderColor(currentTheme),
				borderWidth: getBorderWidth(currentTheme),
				point: {
					events: {
						click: function () {
							vm.onChartClick(this);
						},
					},
				},
			},
		},
		series: seriesConfig,
		responsive: {
			rules: [
				{
					condition: {
						callback: function () {
							vm.responsiveLegend.call(this);
						},
					},
				},
			],
		},
		lang: {
			accessibility: {
				defaultChartTitle: `${vm.chartsI18n.a11y?.defaultChartTitle || ''} ${vm.m42DashboardWidgetCustom?.title || ''}`,
				chartContainerLabel: vm.chartsI18n.a11y?.chartContainerLabel,
				svgContainerLabel: vm.chartsI18n.a11y?.svgContainerLabel,
				screenReaderSection: {
					endOfChartMarker: vm.chartsI18n.a11y?.endOfChartMarker,
				},
				legend: {
					legendLabelNoTitle: vm.chartsI18n.a11y?.legend?.legendLabelNoTitle,
					legendLabel: vm.chartsI18n.a11y?.legend?.legendLabel,
					legendItem: vm.chartsI18n.a11y?.legend?.legendItem,
				},
				chartTypes: {
					emptyChart: vm.chartsI18n.a11y?.chartTypes?.emptyChart,
					combinationChart: vm.chartsI18n.a11y?.chartTypes?.combinationChart,
					defaultSingle: vm.chartsI18n.a11y?.chartTypes?.defaultSingle,
					defaultMultiple: vm.chartsI18n.a11y?.chartTypes?.defaultMultiple,
					splineSingle: vm.chartsI18n.a11y?.chartTypes?.lineSingle,
					splineMultiple: vm.chartsI18n.a11y?.chartTypes?.lineMultiple,
					lineSingle: vm.chartsI18n.a11y?.chartTypes?.lineSingle,
					lineMultiple: vm.chartsI18n.a11y?.chartTypes?.lineMultiple,
					columnSingle: vm.chartsI18n.a11y?.chartTypes?.columnSingle,
					columnMultiple: vm.chartsI18n.a11y?.chartTypes?.columnMultiple,
					barSingle: vm.chartsI18n.a11y?.chartTypes?.barSingle,
					barMultiple: vm.chartsI18n.a11y?.chartTypes?.barMultiple,
					pieSingle: vm.chartsI18n.a11y?.chartTypes?.pieSingle,
					pieMultiple: vm.chartsI18n.a11y?.chartTypes?.pieMultiple,
				},
				axis: {
					xAxisDescriptionSingular: vm.chartsI18n.a11y?.axis?.xAxisDescriptionSingular,
					xAxisDescriptionPlural: vm.chartsI18n.a11y?.axis?.xAxisDescriptionPlural,
					yAxisDescriptionSingular: vm.chartsI18n.a11y?.axis?.yAxisDescriptionSingular,
					yAxisDescriptionPlural: vm.chartsI18n.a11y?.axis?.yAxisDescriptionPlural,
					rangeFromTo: vm.chartsI18n.a11y?.axis?.rangeFromTo,
					rangeCategories: vm.chartsI18n.a11y?.axis?.rangeCategories,
				},
				series: {
					summary: {
						default: vm.chartsI18n.a11y?.series?.summary?.default,
						defaultCombination: vm.chartsI18n.a11y?.series?.summary?.defaultCombination,
						line: vm.chartsI18n.a11y?.series?.summary?.line,
						lineCombination: vm.chartsI18n.a11y?.series?.summary?.lineCombination,
						spline: vm.chartsI18n.a11y?.series?.summary?.line,
						splineCombination: vm.chartsI18n.a11y?.series?.summary?.lineCombination,
						column: vm.chartsI18n.a11y?.series?.summary?.column,
						columnCombination: vm.chartsI18n.a11y?.series?.summary?.columnCombination,
						bar: vm.chartsI18n.a11y?.series?.summary?.bar,
						barCombination: vm.chartsI18n.a11y?.series?.summary?.barCombination,
						pie: vm.chartsI18n.a11y?.series?.summary?.pie,
						pieCombination: vm.chartsI18n.a11y?.series?.summary?.pieCombination,
					},
					xAxisDescription: vm.chartsI18n.a11y?.series?.xAxisDescription,
					yAxisDescription: vm.chartsI18n.a11y?.series?.yAxisDescription,
					nullPointValue: vm.chartsI18n.a11y?.series?.nullPointValue,
				},
			},
			noData: vm.noDataMessage || vm.chartsI18n.noRequiredData,
		},
	};
}
